import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectOrginizationDetails } from "redux/slices/orginizationSlice";
import { isAdminAccount } from "redux/slices/accountSlice";
import { NAVIGATION_ITEM } from "common";
import NavigationContainers from "../navigationContainer";
import i18next from "i18next";
import domainIcon from "resources/icons/domain.svg";

export default function UsersNavigation() {
  const organization = useSelector(selectOrginizationDetails);
  const isAdmin = useSelector(isAdminAccount);
  const location = useLocation();

  return (
    <div className="users-navigation">
      <NavigationContainers items={[NAVIGATION_ITEM.USERS]} />
      {isAdmin && organization?.domainInviteEnabled && (
        <Link
          to="/users/domains"
          className="users-navigation-domain"
        >
          <div
            className={`navigationItem ${
            location.pathname === "/users/domains" ? "selected" : ""
            }`}
          >
            <div className="imageContainer">
              <img src={domainIcon} alt="" className="image" />
            </div>
            <div className="text">{i18next.t("labels.domains")}</div>
          </div>
        </Link>
      )}
    </div>
  );
}
